import { useState } from 'react';
import { AccountPermissionRequest, PartnerAccountPermissionRequest, SubAccountPermissionSection } from 'vopay';
import { api } from '@/services/api.config';

/**
 * One account's permissions tree through the partner routes (ID-13428): the same nested shape the
 * account portal reads for a sub-account, authenticated as the owning partner — so every call takes
 * that partner's bearer (see usePartnerBearer).
 */
export default function usePartnerAccountPermissions() {
  const [fetchingPermissions, setFetchingPermissions] = useState(false);
  const [permissions, setPermissions] = useState<SubAccountPermissionSection[]>([]);

  async function fetchPartnerAccountPermissions(params: PartnerAccountPermissionRequest, bearer: string) {
    try {
      setFetchingPermissions(true);
      const res = await api.fetchPartnerAccountPermissions(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      setPermissions(res.PermissionValues);

      return res;
    } catch (error) {
      setPermissions([]);
      console.error(error);
      throw error;
    } finally {
      setFetchingPermissions(false);
    }
  }

  async function savePartnerAccountPermissions(params: AccountPermissionRequest, bearer: string) {
    try {
      const res = await api.postPartnerAccountPermissions(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { fetchingPermissions, permissions, fetchPartnerAccountPermissions, savePartnerAccountPermissions };
}
